'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence } from 'motion/react';
import DashboardSizeButton from '@/components/common/Card/CardDashboard/CardDashboardHeader/DashboardSizeButton';
import { useDashboardContext } from '@/contexts/Dashboard/Dashboard.context';
interface DashboardHeroTitleProps {
  title: string;
}

/** Must be rendered inside DashboardContextProvider */
const DashboardHeroTitle = t0 => {
  const $ = _c(13);
  const {
    title
  } = t0;
  const {
    isDashboardExpanded,
    isDashboardHovered,
    isSmallDashboard,
    onClickToggleDashboard,
    setIsDashboardHovered
  } = useDashboardContext();
  let t1;
  if ($[0] !== title) {
    t1 = <span className="text-title-xs text-foreground">{title}</span>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isDashboardExpanded || $[3] !== isDashboardHovered || $[4] !== isSmallDashboard || $[5] !== onClickToggleDashboard || $[6] !== setIsDashboardHovered) {
    t2 = !isSmallDashboard && <button data-testid="dashboard-size-button" type="button" onClick={onClickToggleDashboard} onMouseEnter={() => setIsDashboardHovered(true)} onMouseLeave={() => setIsDashboardHovered(false)} className="cursor-pointer border-none bg-transparent p-0"><DashboardSizeButton isExpanded={isDashboardExpanded} isHovered={isDashboardHovered} /></button>;
    $[2] = isDashboardExpanded;
    $[3] = isDashboardHovered;
    $[4] = isSmallDashboard;
    $[5] = onClickToggleDashboard;
    $[6] = setIsDashboardHovered;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <AnimatePresence mode="wait">{t2}</AnimatePresence>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t3) {
    t4 = <div data-testid="dashboard-section-title" className="gap-xs flex items-center justify-between">{t1}{t3}</div>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default DashboardHeroTitle;